import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function Pagination({ page, pages, total, onPageChange }) {
  if (!total || total === 0) return null;

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200" data-testid="pagination">
      <p className="text-sm text-slate-600">
        Page {page} of {pages} ({total} total)
      </p>
      <div className="flex items-center gap-1">
        <Button
          size="sm"
          variant="outline"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="h-8 w-8 p-0"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        {Array.from({ length: Math.min(pages, 5) }, (_, i) => {
          let pageNum;
          if (pages <= 5) {
            pageNum = i + 1;
          } else if (page <= 3) {
            pageNum = i + 1;
          } else if (page >= pages - 2) {
            pageNum = pages - 4 + i;
          } else {
            pageNum = page - 2 + i;
          }
          return (
            <Button
              key={pageNum}
              size="sm"
              variant={pageNum === page ? 'default' : 'outline'}
              onClick={() => onPageChange(pageNum)}
              className={`h-8 w-8 p-0 text-xs ${pageNum === page ? 'bg-[#005DE8]' : ''}`}
              data-testid={`pagination-page-${pageNum}`}
            >
              {pageNum}
            </Button>
          );
        })}
        <Button
          size="sm"
          variant="outline"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= pages}
          className="h-8 w-8 p-0"
          data-testid="pagination-next"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
